var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20782_77864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 15.0003H6.66675M10.0001 15.0003H15.0001M5.83341 1.66699H14.1667C15.0872 1.66699 15.8334 2.41318 15.8334 3.33366V6.66699C15.8334 7.58747 15.0872 8.33366 14.1667 8.33366H5.83341C4.91294 8.33366 4.16675 7.58747 4.16675 6.66699V3.33366C4.16675 2.41318 4.91294 1.66699 5.83341 1.66699ZM3.33341 11.667H16.6667C17.5872 11.667 18.3334 12.4132 18.3334 13.3337V16.667C18.3334 17.5875 17.5872 18.3337 16.6667 18.3337H3.33341C2.41294 18.3337 1.66675 17.5875 1.66675 16.667V13.3337C1.66675 12.4132 2.41294 11.667 3.33341 11.667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20782_77864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.d9b0172667c3208195300399c69cbab5.svg";
export { ForwardRef as ReactComponent };